import { render, staticRenderFns } from "./tagsListModal.vue?vue&type=template&id=16ba6174&scoped=true&"
import script from "./tagsListModal.vue?vue&type=script&lang=js&"
export * from "./tagsListModal.vue?vue&type=script&lang=js&"
import style0 from "./tagsListModal.vue?vue&type=style&index=0&lang=less&"
import style1 from "./tagsListModal.vue?vue&type=style&index=1&id=16ba6174&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ba6174",
  null
  
)

export default component.exports